import { LiftInterface } from "./Lift.interface";
import { BankFloorInterface } from "./Bank.interface";
import { WSMsgType } from "../flatbuffers/types/uiMessageTypes";

export type DoorSelectedType = "FRONT" | "REAR" | "NA";
export type LockUnlockType = "lck" | "unlck" | "NA";
export type UpDownType = "UP" | "DOWN" | "NA";
export type CarCallHallCallType = "CARCALL" | "HALLCALL" | "VIP" | "NA";
export type EmulatorMessageType = "CONTROL" | "CARCALL" | "HALLCALL" | "VIP" | "VIP_RESET" | "COMMAND";
export type SocketDirection = "Up" | "Down" | "Left" | "Right" | "Idle";

export const VALID_MESSAGES_NO_ICON = ["PF", "FAULT"];
export const VALID_TYPES = ["FAULT", "CARSERVICE", "TRAFFIC", "STATUS"];

export enum MonitoringViewTypeEnum {
	EXPANDED_VIEW,
	OVER_HEAD_VIEW,
	STATUS_VIEW,
	DEVICE_STATUS_VIEW,
	MAP_VIEW,
}
export interface ControlPanelComponentRearFrontRadioGroupInterface {
	doorSelected: DoorSelectedType;
	setDoorSelected: (value: DoorSelectedType) => void;
}

export interface ControlPanelBankFloors {
	id: string;
	name: string;
	floor_no: number;
	front_door: boolean;
	rear_door: boolean;
}

export interface ControlPanelBankVIPInterface {
	hasFrontDoors: boolean;
	hasRearDoors: boolean;
	bankFloors: ControlPanelBankFloors[];
}

export interface postCommandEdgeCarCallFlatBufferInterface {
	frontRearDoorType: DoorSelectedType;
	lockUnlockType: LockUnlockType;
	isSecureCalls: boolean;
	floor: number;
	isCmdOff: boolean;
}

export interface postCommandEdgeHallCallFlatBufferInterface {
	frontRearDoorType: DoorSelectedType;
	lockUnlockType: LockUnlockType;
	upDownType: UpDownType;
	isSecureCalls: boolean;
	floor: number;
	isCmdOff: boolean;
}

export interface postCommandEdgeCMDInterface {
	isAdapter: boolean;
	isCmdOff: boolean;
	cmdMessage: string;
	carCallHallCallType: CarCallHallCallType;
}

export interface CarCallsInterface {
	front: number[];
	rear: number[];
	front_lock: number[];
	rear_lock: number[];
}

export interface HallCallsInterface {
	up: CarCallsInterface;
	down: CarCallsInterface;
	up_assigned: CarCallsInterface;
	down_assigned: CarCallsInterface;
}

export interface IconInterface {
	type: string;
	name: string;
	description: string;
}

export interface DoorStatusInterface {
	front_open: boolean;
	rear_open: boolean;
}

export interface SocketMessageInterface {
	bank_id: string;
	lift_id: string;
	car_calls: CarCallsInterface;
	hall_calls: HallCallsInterface;
	faults: string[];
	fault_strings: string[];
	position: number;
	service_mode: string;
	direction: SocketDirection;
	door_status: DoorStatusInterface;
	connected: boolean;
	msg: {
		active: boolean;
		type: WSMsgType;
		value: string;
	};
}

export interface DeviceViewDataByServerInterface {
	idServer: string;
	nameServer: string;
	lifts: { id: string; name: string; bank: string }[];
	liftsChunks: { id: string; name: string; bank: string }[][];
}

export interface DeviceViewDataByBankInterface {
	idBank: string;
	nameBank: string;
	lifts: { id: string; name: string }[];
	liftsChunks: { id: string; name: string }[][];
}

export interface MonitoringDeviceConfigurationInterface {
	showElevators: boolean;
	showEscalators: boolean;
	showMovingwalks: boolean;
	showGpio: boolean;
	viewType: "server" | "bank";
}

export interface LayoutInterface {
	value: string;
	label: string;
	children: any[];
	type: string;
	fbEnabled: boolean;
	idOrganization: string;
	idServer: string;
	idChannel: string;
	idBank: string;
	nameOrganization: string;
	nameServer: string;
	nameChannel: string;
	typeChannel: string;
	id: string;
	created_at?: string;
	updated_at?: string;
	deleted_at?: string | null;
	active: boolean;
	board: number;
	columns: number;
	floor_below_lobby: number;
	floor_count: number;
	logical_port: number;
	name: string;
	number_of_lifts: number;
	channel_id: string;
	rear_doors: boolean;
	stops: number;
	control_panel: any;
	bank_floors: BankFloorInterface[];
	lifts: LiftInterface[];
	floorsInUse: any[];
	i: string;
	x: number;
	y: number;
	w: number;
	h: number;
	l: number;
	f: number;
	floor: number;
	actions?: any;
	start_floor_no: number;
	cmdBinaryControl: boolean;
}

export interface TerminalGlobalObject {
	id: string;
	name: string;
	channelId: string;
	serverId: string;
	liftId: string;
	bankId: string;
}
